import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import styles from './options.module.scss';

class Options extends Component {
    render() {
        const containerStyle = {
            backgroundColor: '#5268b3',
            color: 'white'
        }
        const checkBoxStyle = {
            backgroundColor: 'white',
            borderColor: 'white'
        }
        const { option, onOptionClick, isHighlighted } = this.props;
        return (
            <div
                className={styles['option-container']}
                onClick={() => onOptionClick(option.id)}
                style={isHighlighted ? containerStyle : {}}
            >
                <div className={styles['checkbox']} style={isHighlighted ? checkBoxStyle : {}} />
                <div className={styles['option-text']}>
                    {option.text}
                </div>
            </div>
        )
    }
}

Options.propTypes = {};

Options.defaultProps = {};

export default Options;


// WEBPACK FOOTER //
// /src/components/commonComponents/surveyView/questions/options/Options.js